import { Card, CardBody, Col, Row } from "reactstrap";
import HandleDateTime from "../../../../../../Components/Common/HandleDateTime";
import {
  foodPreOrderEventGuestAccept,
  foodPreOrderEventGuestAcceptSuccess,
  foodPreOrderEventGuestData,
  foodPreOrderEventGuestDecline,
  foodPreOrderEventGuestDeclineSuccess,
  foodPreOrderEventGuestSearch,
} from "../../../../../../store/foodPreOederEvent/action";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import React, { useEffect } from "react";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import LoadingSpinner from "../../../../../../Components/Common/Spinner";
import MapDetails from "../../../../../Customer/single/tabOverview/mapDetails";

const EventDetails = ({
  eventDetails,
  eventUserData,
  branding,
  setActiveTab,
}) => {
  const params = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      foodPreOrderEventGuestData(
        { id: eventUserData?.data?.FoodPreOrderEventGuest_Id },
        params?.token
      )
    );
  }, []);
  const { foodPreOrderEventGuestDataAPI, foodPreOrderEventGuestDataLoading } =
    useSelector((state) => ({
      foodPreOrderEventGuestDataAPI:
        state.FoodPreOrderEventReducer.foodPreOrderEventGuestData
          ?.foodpreordereventguest_data,
      foodPreOrderEventGuestDataLoading:
        state.FoodPreOrderEventReducer.foodPreOrderEventGuestDataLoading,
    }));

  const handleAcceptDeclineInvite = (type) => {
    if (type === "accept") {
      dispatch(
        foodPreOrderEventGuestAccept(
          { id: eventUserData?.data?.FoodPreOrderEventGuest_Id },
          params?.token
        )
      );
    }
    if (type === "decline") {
      dispatch(
        foodPreOrderEventGuestDecline(
          { id: eventUserData?.data?.FoodPreOrderEventGuest_Id },
          params?.token
        )
      );
    }
  };
  const { foodPreOrderEventGuestAcceptAPI, foodPreOrderEventGuestDeclineAPI } =
    useSelector((state) => ({
      foodPreOrderEventGuestAcceptAPI:
        state.FoodPreOrderEventReducer.foodPreOrderEventGuestAccept,
      foodPreOrderEventGuestDeclineAPI:
        state.FoodPreOrderEventReducer.foodPreOrderEventGuestDecline,
    }));

  //Accept
  useEffect(() => {
    if (isEmpty(foodPreOrderEventGuestAcceptAPI)) return;
    if (foodPreOrderEventGuestAcceptAPI.status === 200) {
      toast.success(foodPreOrderEventGuestAcceptAPI?.message);
      dispatch(
        foodPreOrderEventGuestData(
          { id: eventUserData?.data?.FoodPreOrderEventGuest_Id },
          params?.token
        )
      );
      dispatch(
        foodPreOrderEventGuestSearch(
          [
            {
              foodpreorderevent: {
                Id: eventUserData?.data?.FoodPreOrderEvent_Id,
              },
            },
          ],
          params?.token
        )
      );
      setActiveTab("2");
    } else {
      toast.error(foodPreOrderEventGuestAcceptAPI?.message);
    }

    dispatch(foodPreOrderEventGuestAcceptSuccess([]));
  }, [foodPreOrderEventGuestAcceptAPI]);

  //Decline
  useEffect(() => {
    if (isEmpty(foodPreOrderEventGuestDeclineAPI)) return;
    if (foodPreOrderEventGuestDeclineAPI.status === 200) {
      toast.success(foodPreOrderEventGuestDeclineAPI?.message);
      dispatch(
        foodPreOrderEventGuestData(
          { id: eventUserData?.data?.FoodPreOrderEventGuest_Id },
          params?.token
        )
      );
      dispatch(
        foodPreOrderEventGuestSearch(
          [
            {
              foodpreorderevent: {
                Id: eventUserData?.data?.FoodPreOrderEvent_Id,
              },
            },
          ],
          params?.token
        )
      );
    } else {
      toast.error(foodPreOrderEventGuestDeclineAPI?.message);
    }

    dispatch(foodPreOrderEventGuestDeclineSuccess([]));
  }, [foodPreOrderEventGuestDeclineAPI]);

  return (
    <div>
      <Row className={"my-4"}>
        <Col lg={12}>
          <div className={"d-flex flex-column align-items-center"}>
            {foodPreOrderEventGuestDataLoading ? (
              <LoadingSpinner />
            ) : (
              <div className={"text-center"}>
                <div className={"p-2"}>
                  <h5
                    style={{
                      fontFamily: branding?.PortalCssFontFamilyDivHeading,
                    }}
                  >
                    Please Accept or decline the invitation to the event
                  </h5>
                  Invitation Status:{" "}
                  {foodPreOrderEventGuestDataAPI?.FoodPreOrderEventGuestStatus_Name && (
                    <span>
                      {
                        foodPreOrderEventGuestDataAPI?.FoodPreOrderEventGuestStatus_Name
                      }
                    </span>
                  )}
                </div>
                <button
                  disabled={
                    foodPreOrderEventGuestDataAPI?.FoodPreOrderEventGuestStatus_Id ===
                    "2"
                  }
                  className={"btn btn-success"}
                  onClick={() => {
                    handleAcceptDeclineInvite("accept");
                  }}
                >
                  Accept
                </button>{" "}
                <button
                  disabled={
                    foodPreOrderEventGuestDataAPI?.FoodPreOrderEventGuestStatus_Id ===
                    "3"
                  }
                  className={"btn btn-danger"}
                  onClick={() => {
                    handleAcceptDeclineInvite("decline");
                  }}
                >
                  Decline
                </button>
              </div>
            )}
            <div className={"d-flex flex-row justify-content-center mt-4"}>
              <hr />
              <h4
                style={{ fontFamily: branding?.PortalCssFontFamilyDivHeading }}
              >
                {eventDetails?.FoodPreOrderSiteLocation_BusinessName}
              </h4>
            </div>
            <div className={"d-flex flex-row justify-content-center pb-2"}>
              <h5
                style={{ fontFamily: branding?.PortalCssFontFamilyDivHeading }}
              >
                Event {eventDetails?.Title}
              </h5>
            </div>
            <div className={"d-flex flex-row"}>
              Event Date: {HandleDateTime(eventDetails?.EventDateTime)}
            </div>
            <div className={"d-flex flex-row"}>
              Pre-order Opens{" "}
              {HandleDateTime(eventDetails?.PreOrderAllowedStartDateTime)}
            </div>
            <div className={"d-flex flex-row"}>
              Pre-order Closes{" "}
              {HandleDateTime(eventDetails?.PreOrderAllowedEndDateTime)}
            </div>{" "}
            <div className={"d-flex flex-row"}>
              Address:{" "}
              <span>
                {eventDetails?.FoodPreOrderSiteLocation_AddressLine1 &&
                  eventDetails?.FoodPreOrderSiteLocation_AddressLine1 + ", "}
                {eventDetails?.FoodPreOrderSiteLocation_AddressLine2 &&
                  eventDetails?.FoodPreOrderSiteLocation_AddressLine2 + ", "}
                {eventDetails?.FoodPreOrderSiteLocation_AddressLine3 &&
                  eventDetails?.FoodPreOrderSiteLocation_AddressLine3 + ", "}
                {eventDetails?.FoodPreOrderSiteLocation_AddressLine4 &&
                  eventDetails?.FoodPreOrderSiteLocation_AddressLine4 + ", "}
                {eventDetails?.FoodPreOrderSiteLocation_AddressCity &&
                  eventDetails?.FoodPreOrderSiteLocation_AddressCity + ", "}
                {eventDetails?.FoodPreOrderSiteLocation_AddressCounty &&
                  eventDetails?.FoodPreOrderSiteLocation_AddressCounty + ", "}
                {eventDetails?.FoodPreOrderSiteLocation_AddressPostcode &&
                  eventDetails?.FoodPreOrderSiteLocation_AddressPostcode}
              </span>
            </div>
            <hr />
            <div className={"w-100"}>
              <MapDetails
                customTitle={"Event Location"}
                singleCustomerPostcode={
                  eventDetails?.FoodPreOrderSiteLocation_BusinessName
                }
              />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default EventDetails;
